import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { electricMedia } from "../apiPath/api";

export const createElectronicMedia = createAsyncThunk(
  "electricMedia/createElectronicMedia",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await electricMedia.createElectricMedia(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllElectricMedia = createAsyncThunk(
  "electricMedia/getAllElectricMedia",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await electricMedia.getAllElectricMedia(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deleteElectricMedia = createAsyncThunk(
  "electricMedia/deleteElectricMedia",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await electricMedia.deleteElectricMedia(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeleteElectricMedia = createAsyncThunk(
  "electricMedia/undoDeleteElectricMedia",
  async (id, { rejectWithValue }) => {
    try {
      const response = await electricMedia.undoDeleteElectricMedia(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updateElectricMedia = createAsyncThunk(
  "electricMedia/updateElectricMedia",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await electricMedia.updateElectricMedia(id, data);
      return response.data;
    } catch (error) {
      console.error("Update error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update electric media"
      );
    }
  }
);

const electricMediaSlice = createSlice({
  name: "electricMedia",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    electricMedia: [],
  },

  reducers: {
    resetElectricMediaState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.electricMedia = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createElectronicMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createElectronicMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createElectronicMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllElectricMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllElectricMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.electricMedia = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllElectricMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteElectricMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteElectricMedia.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteElectricMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeleteElectricMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeleteElectricMedia.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeleteElectricMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateElectricMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateElectricMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updateElectricMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetElectricMediaState } = electricMediaSlice.actions;
export default electricMediaSlice.reducer;
